import controller from './load-cart.controller';

let LoadCartComponent = {
    template: `
        <div class="container" style="height:400px;display:flex;justify-content:center;align-items:center;">
            <div class="text-center m30">
                <i class="fa fa-spinner fa-pulse"></i>
                <span>Cargando información del carrito</span>
            </div>
        </div>
    `,
    controller,
    bindings: {  
        shCtrl: '<'
    }
};

export default LoadCartComponent;


/** WEBPACK FOOTER **
 ** ./www/components/load-cart/load-cart.component.js
 **/